import { Head, Link, useForm } from '@inertiajs/react'
import Flash from '../../components/Flash'

const FLOATIES = [
  { emoji: '💌', className: 'left-[8%] top-[16%] text-6xl', delay: '0s' },
  { emoji: '🎈', className: 'right-[10%] top-[12%] text-5xl', delay: '1.2s' },
  { emoji: '🌙', className: 'left-[14%] bottom-[14%] text-5xl', delay: '2.1s' },
  { emoji: '⭐️', className: 'right-[16%] bottom-[20%] text-4xl', delay: '0.6s' },
  { emoji: '🐣', className: 'right-[26%] top-[46%] text-4xl', delay: '3s' },
]

function Field({ id, label, hint, error, children }) {
  return (
    <div>
      <label htmlFor={id} className="mb-1.5 block font-display font-bold text-ink-soft">
        {label}
        {hint && <span className="font-normal"> {hint}</span>}
      </label>
      {children}
      {error && <p className="mt-1 text-sm font-bold text-rose-600">{error}</p>}
    </div>
  )
}

export default function RequestAccess({ username, name, email, relation }) {
  const { data, setData, post, processing, errors } = useForm({
    name: name || '',
    username: username || '',
    email: email || '',
    relation: relation || '',
    password: '',
    password_confirmation: '',
  })

  function submit(event) {
    event.preventDefault()
    post('/request-access')
  }

  return (
    <>
      <Head title="Request an account" />
      <Flash />

      <main className="relative flex min-h-screen items-center justify-center overflow-hidden px-5 py-12">
        {FLOATIES.map((floaty) => (
          <span
            key={floaty.emoji}
            aria-hidden="true"
            style={{ animationDelay: floaty.delay }}
            className={`animate-float-slow pointer-events-none absolute hidden opacity-70 select-none sm:block ${floaty.className}`}
          >
            {floaty.emoji}
          </span>
        ))}

        <div className="card-cute animate-pop-in w-full max-w-md p-8">
          <div className="mb-7 text-center">
            <span className="animate-float-slow inline-block text-6xl" aria-hidden="true">
              💌
            </span>
            <h1 className="mt-3 font-display text-4xl font-extrabold text-ink">Ask to join</h1>
            <p className="mt-2 text-ink-soft">
              Pick your username and password, and mum or dad will wave you in.
            </p>
          </div>

          <form onSubmit={submit} className="space-y-4">
            <Field id="name" label="Your name" error={errors.name}>
              <input
                id="name"
                type="text"
                value={data.name}
                onChange={(event) => setData('name', event.target.value)}
                required
                autoFocus
                autoComplete="name"
                placeholder="Gin Gin"
                className="input-cute"
              />
            </Field>

            <Field id="username" label="Username" error={errors.username}>
              <input
                id="username"
                type="text"
                value={data.username}
                onChange={(event) => setData('username', event.target.value)}
                required
                autoComplete="username"
                autoCapitalize="none"
                spellCheck="false"
                placeholder="gin_gin"
                className="input-cute"
              />
            </Field>

            <Field id="email" label="Email" error={errors.email}>
              <input
                id="email"
                type="email"
                value={data.email}
                onChange={(event) => setData('email', event.target.value)}
                required
                autoComplete="email"
                autoCapitalize="none"
                spellCheck="false"
                placeholder="gin.gin@example.com"
                className="input-cute"
              />
            </Field>

            <Field id="relation" label="Relation" hint="(optional)" error={errors.relation}>
              <input
                id="relation"
                type="text"
                value={data.relation}
                onChange={(event) => setData('relation', event.target.value)}
                placeholder="Grandma"
                className="input-cute"
              />
            </Field>

            <Field id="password" label="Password" error={errors.password}>
              <input
                id="password"
                type="password"
                value={data.password}
                onChange={(event) => setData('password', event.target.value)}
                required
                maxLength={72}
                autoComplete="new-password"
                placeholder="At least 8 characters"
                className="input-cute"
              />
            </Field>

            <Field id="password_confirmation" label="Confirm password" error={errors.password_confirmation}>
              <input
                id="password_confirmation"
                type="password"
                value={data.password_confirmation}
                onChange={(event) => setData('password_confirmation', event.target.value)}
                required
                maxLength={72}
                autoComplete="new-password"
                className="input-cute"
              />
            </Field>

            <button
              type="submit"
              disabled={processing}
              className="btn-cute w-full bg-blush-400 py-3 text-lg text-white shadow-lg hover:bg-blush-500"
            >
              {processing ? 'Sending…' : 'Send my request 💌'}
            </button>
          </form>

          <p className="mt-6 text-center text-sm text-ink-soft/80">
            Already in?{' '}
            <Link href="/session/new" className="font-bold text-blush-500 underline-offset-2 hover:underline">
              Sign in
            </Link>
          </p>
        </div>
      </main>
    </>
  )
}
